import React from 'react';
import { ChipContainer, ChipIconImage, ChipText } from './styled-components';
import { ChipProps } from './chip-icon-types';
import { useTheme } from '@/contexts/theme-context/useThemeContext';

export const ChipWithIcon: React.FC<ChipProps> = ({ 
    icon, 
    text, 
    variant = 'default' ,
    fontSize
}) => {
    const theme = useTheme();
    const isDarkMode = theme.theme.name === 'dark';
    
    return (
        <ChipContainer $variant={variant} $isDarkMode={isDarkMode}>
            {icon && <ChipIconImage src={icon} alt="chip icon" $isDarkMode={isDarkMode} />}
            <ChipText $isDarkMode={isDarkMode} $fontSize={fontSize}>{text}</ChipText>
        </ChipContainer>
    );
};

export default ChipWithIcon;